import { ReactComponent as PresentIcon } from "assets/icons/icon_office.svg";
import { ReactComponent as AbsentIcon } from "assets/icons/icon_absent.svg";
import { ReactComponent as RemoteIcon } from "assets/icons/icon_remote.svg";
import { ReactComponent as DelegationIcon } from "assets/icons/icon_delegation.svg";
import { ReactComponent as VacationIcon } from "assets/icons/icon_vacation.svg";
import { ReactComponent as HolidayIcon } from "assets/icons/icon_holiday.svg";
import { ReactComponent as SickLeaveIcon } from "assets/icons/icon_sickleave.svg";

export const PRESENCE = {
    PRESENT: "PRESENT",
    REMOTE: "REMOTE",
    DELEGATION: "DELEGATION",
    SICK_LEAVE: "SICK_LEAVE",
    VACATION: "VACATION",
    ABSENT: "ABSENT",
    HOLIDAY: "HOLIDAY",
    WEEKEND: "WEEKEND",
    UNSET: "UNSET",
};

export const PRESENCE_DICTIONARY = {
    [PRESENCE.PRESENT]: "Work - Office",
    [PRESENCE.REMOTE]: "Work - Remote",
    [PRESENCE.DELEGATION]: "Work - Business travel",
    [PRESENCE.VACATION]: "Absent - Vacation",
    [PRESENCE.SICK_LEAVE]: "Absent - Sick",
    [PRESENCE.ABSENT]: "Absent - Other",
    [PRESENCE.HOLIDAY]: "Public Holiday",
    [PRESENCE.WEEKEND]: "Weekend",
};

export const PRESENCE_TO_HINT = {
    [PRESENCE.PRESENT]: "Work in the office",
    [PRESENCE.REMOTE]: "Remote work from home",
    [PRESENCE.DELEGATION]: "Remote work during business travel",
    [PRESENCE.VACATION]: "Not working because of having vacation or annual leave",
    [PRESENCE.SICK_LEAVE]: "Not working because of illness",
    [PRESENCE.ABSENT]: "Not working because of other reasons",
};

export const PRESENCE_TO_ICON_COMPONENT = {
    [PRESENCE.PRESENT]: PresentIcon,
    [PRESENCE.ABSENT]: AbsentIcon,
    [PRESENCE.REMOTE]: RemoteIcon,
    [PRESENCE.DELEGATION]: DelegationIcon,
    [PRESENCE.VACATION]: VacationIcon,
    [PRESENCE.HOLIDAY]: HolidayIcon,
    [PRESENCE.SICK_LEAVE]: SickLeaveIcon,
};

export const MANAGE_PRESENCE = {
    UPDATE: "UPDATE",
    DO_NOT_CHANGE: "DO_NOT_CHANGE",
};

export const PROJECT_ABSENCES = "QZ2300";
export const PROJECT_FAMILY_AND_HEALTH = "QZ2308";
export const PRESENT_PRESENCES = [PRESENCE.PRESENT, PRESENCE.REMOTE, PRESENCE.DELEGATION];
export const ABSENT_PRESENCES = [PRESENCE.SICK_LEAVE, PRESENCE.VACATION, PRESENCE.ABSENT];
export const ABSENT_PROJECTS = [PROJECT_ABSENCES, PROJECT_FAMILY_AND_HEALTH];
export const ABSENT_PROJECTS_EXPANDED = [PROJECT_ABSENCES, PROJECT_FAMILY_AND_HEALTH, "INZ0", "MYZ0", "UKZ000", "CHZ0006"];
export const HIDDEN_PRESENCES = [PRESENCE.WEEKEND, PRESENCE.HOLIDAY];
export const SELECTABLE_PRESENCES = [...PRESENT_PRESENCES, ...ABSENT_PRESENCES];
